import PointsShopReward from './PointsShopReward'
import { PointsShopRewardModalProps } from './PointsShopReward'

export type { PointsShopRewardModalProps }

export default PointsShopReward
